import React from 'react';

const palette = {
  teal: '#0784a7',
  tealDark: '#055f7a',
  ink: '#1e272e',
  inkSoft: '#4a5560',
  pageBg: '#f5f7fb',
};

const styles = {
  shell: {
    minHeight: '100vh',
    background: palette.pageBg,
    fontFamily: 'Montserrat, Inter, system-ui, sans-serif',
    color: palette.ink,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 24,
    boxSizing: 'border-box',
  },
  card: {
    maxWidth: 480,
    width: '100%',
    background: '#fff',
    borderRadius: 14,
    padding: '40px 32px',
    boxShadow: '0 8px 24px rgba(15, 30, 50, 0.06)',
    textAlign: 'center',
  },
};

// This route exists for completeness, but in the default unsubscribe flow the
// backend itself renders the confirmation HTML directly (no React round-trip).
// Kept here so manual links to /share/unsubscribe-confirm still resolve to
// something branded.
const ShareUnsubscribePage = () => (
  <div style={styles.shell}>
    <div style={styles.card}>
      <h2 style={{ marginTop: 0, color: palette.teal }}>You're unsubscribed</h2>
      <p style={{ color: palette.inkSoft }}>We won't send you any more Multiply meeting summaries.</p>
      <p style={{ marginTop: 24 }}>
        <a href='https://askmultiply.com' style={{ color: palette.teal, fontWeight: 600 }}>Learn about Multiply</a>
      </p>
    </div>
  </div>
);

export default ShareUnsubscribePage;
